/** vendor */
import { useSelector } from 'react-redux'

/** lib */
import { IMG_URL, PLACEHOLDER_IMG } from '../../constants/ApiConfiguration'

/** components */
import TagIcons from '../UI/TagIcons'

export default function IngredientListItem({
    ingredient,
}) {
    const categoryOptions = useSelector(state => state.form_options?.category_options || [])
    
    const handleClick = (ingredient_id) => {}

    const getCategoryName = (category_id) => {
        return categoryOptions?.find(c => parseInt(c.value) === parseInt(category_id))?.name ?? 'Uknown'
    }

    const ingredientImage = (ingredient?.image) ? `${IMG_URL}/${ingredient.image}` : PLACEHOLDER_IMG

    return (
        <div className="w-full p-1 relative">
            <small className="text-left text-an_green block text-[10px]">
                {getCategoryName(ingredient.category_id)}
            </small> 
            <div 
                className="flex cursor-pointer" 
                onClick={() => {  }}
            >
                <div className="flex-shrink-0">
                    {
                        ingredientImage && 
                            <div className="my-1">
                                <img src={ingredientImage} className="w-14 md:w-40 rounded border border-an_green-dark"/>
                            </div>
                    }
                </div>

                <div className="flex-grow flex flex-col pl-4">
                    <div className="pb-10 pt-4">          
                        <div className="text-an_green-dark text-xl">
                            { ingredient.name } { ingredient.name_ext }
                        </div>
                        <div className="text-left flex-wrap flex-shrink-1 py-1 text-an_green-dark">
                            {ingredient.description}
                        </div>  
                    </div>

                    <div className="absolute bottom-2 right-0 flex w-full justify-end items-center">
                        <div>
                            <TagIcons
                                fodMapWarning={ingredient.fodmap_rating}
                                allergenWarning={ingredient.allergen}
                                allergenDialog={
                                    (e) => { 
                                        e.stopPropagation()
                                    }
                                }
                                vegetarian={ingredient.vegetarian}
                                vegan={ingredient.vegan}
                                glutenFree={ingredient.gluten_free}
                                sugarFree={ingredient.sugar_free}
                                dairyFree={ingredient.dairy_free}
                            />           
                        </div>                        
                    </div>

                </div>
            </div>
        </div>
    )
}